import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { OfflineDatabaseClassificationType } from '../database/offlineDatabase/types/offlineDatabaseClassificationType.types';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';
import { createOfflineFilterOptionsRepository } from './filterOptions/createOfflineFilterOptionsRepository';

const commonRepository = createOfflineCommonRepository<OfflineDatabaseClassificationType, 'id'>(
  () => offlineDatabase.classificationTypes,
);

const filterOptionsRepository = createOfflineFilterOptionsRepository<
  OfflineDatabaseClassificationType,
  'id'
>(() => offlineDatabase.classificationTypes);

export const offlineClassificationTypesRepository = {
  ...commonRepository,
  ...filterOptionsRepository,
  findAllUsedAsTag: () => {
    const databaseTable = offlineDatabase.classificationTypes;
    return databaseTable.filter((item) => item.useAsTag).toArray();
  },
  findAllUsedAsFilter: () => {
    const databaseTable = offlineDatabase.classificationTypes;
    return databaseTable.filter((item) => item.useAsFilter).toArray();
  },
};
